var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white--text ml-3",attrs:{"depressed":"","outlined":"","small":"","color":"red","fab":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("mdi-delete")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }